/*! Copyright (c) 2013 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.1.3
 *
 * Requires: 1.2.2+
 */

(function(factory) {
  factory(jQuery);
})(function($) {
  var toFix = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'];
  var toBind =
    'onwheel' in document || document.documentMode >= 9
      ? ['wheel']
      : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'];
  var isWin = navigator.platform.toUpperCase().indexOf('WIN') >= 0;
  var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  var isFF = navigator.userAgent.toUpperCase().indexOf('FIREFOX') >= 0;
  var isOpera = navigator.userAgent.toUpperCase().indexOf('OPERA') >= 0;

  if ($.event.fixHooks) {
    for (var i = toFix.length; i; ) {
      $.event.fixHooks[toFix[--i]] = $.event.mouseHooks;
    }
  }

  $.event.special.mousewheel = {
    setup: function() {
      if (this.addEventListener) {
        for (var i = toBind.length; i; ) {
          this.addEventListener(toBind[--i], handler, false);
        }
      } else {
        this.onmousewheel = handler;
      }
    },

    teardown: function() {
      if (this.removeEventListener) {
        for (var i = toBind.length; i; ) {
          this.removeEventListener(toBind[--i], handler, false);
        }
      } else {
        this.onmousewheel = null;
      }
    },
  };

  $.fn.extend({
    mousewheel: function(fn) {
      return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
    },

    unmousewheel: function(fn) {
      return this.unbind('mousewheel', fn);
    },
  });

  function handler(event) {
    var orgEvent = event || window.event,
      args = [].slice.call(arguments, 1),
      delta = 0,
      deltaX = 0,
      deltaY = 0,
      fn;
    event = $.event.fix(orgEvent);
    event.type = 'mousewheel';

    // Old school scrollwheel delta
    if (orgEvent.detail) {
      delta = orgEvent.detail * -1;
    } //обязательно сначала проверка на .detail
    if (orgEvent.wheelDelta) {
      delta = orgEvent.wheelDelta;
    } //а потом уже на .wheelDelta

    // New school wheel delta (wheel event)
    if (orgEvent.deltaY) {
      deltaY = orgEvent.deltaY * -1;
      delta = deltaY;
    }
    if (orgEvent.deltaX) {
      deltaX = orgEvent.deltaX * -1;
      delta = deltaX;
    }

    // Webkit
    if (orgEvent.wheelDeltaY !== undefined) {
      deltaY = orgEvent.wheelDeltaY;
    }
    if (orgEvent.wheelDeltaX !== undefined) {
      deltaX = orgEvent.wheelDeltaX;
    }

    var k = 1;

    //на mac + ff + мышь delta очень маленькая и всегда дробная, так мы эту связку и определяем (обычные значения 0.100xxxxxx)
    if (isMac && isFF && Math.abs(delta - Math.round(delta)) > 0.0000001) k *= 120;

    if (isWin && isFF) k *= 40;

    if (isMac && isOpera) k /= 15;

    delta *= k;
    deltaX *= k;
    deltaY *= k;

    // Add event and delta to the front of the arguments
    args.unshift(event, delta, deltaX, deltaY);

    return ($.event.dispatch || $.event.handle).apply(this, args);
  }
});
